<template>
  <div>
    <v-card class="pt-1" height="428px" flat>
      <!-- {{ itemMostrarDetalhes.feedback_comportamento }}<br>
      {{ 'GEROU ' + itemMostrarDetalhes.resposta_email_de_quem_gerou }}<br>
      {{ 'NAO GEROU ' + itemMostrarDetalhes.resposta_email_de_quem_nao_gerou }} -->
      <v-row no-gutters>
        <v-col v-if="itemMostrarDetalhes.resposta_email_de_quem_gerou" md="12" class="mr-2">
          <div class="title mb-4">
            <h5 class="ml-2">RESPOSTA DE QUEM GEROU</h5>
          </div>
          <!-- <v-divider class="my-3 mb-4"/> -->
          <table style="width: 100%">
            <tr>
              <th>OPÇÕES</th>
              <th class="align-center" width="100px">RESPOSTA</th>
            </tr>
            <tr :class="itemMostrarDetalhes.resposta_email_de_quem_gerou === '01' ? 'bold' : ''">
              <td>Efetuei a compra em outra empresa.</td>
              <td>
                <v-checkbox
                  class="checks"
                  color="primary"
                  readonly
                  v-model="itemMostrarDetalhes.resposta_email_de_quem_gerou"
                  value="01"
                ></v-checkbox>
              </td>
            </tr>
            <tr :class="itemMostrarDetalhes.resposta_email_de_quem_gerou === '02' ? 'bold' : ''">
              <td>Orçamento pendente de aprovação pela gerência.</td>
              <td>
                <v-checkbox
                  class="checks"
                  color="primary"
                  readonly
                  v-model="itemMostrarDetalhes.resposta_email_de_quem_gerou"
                  value="02"
                ></v-checkbox>
              </td>
            </tr>
            <tr :class="itemMostrarDetalhes.resposta_email_de_quem_gerou === '03' ? 'bold' : ''">
              <td>Não houve tempo suficiente para a análise.</td>
              <td>
                <v-checkbox
                  class="checks"
                  color="primary"
                  readonly
                  v-model="itemMostrarDetalhes.resposta_email_de_quem_gerou"
                  value="03"
                ></v-checkbox>
              </td>
            </tr>
            <tr :class="itemMostrarDetalhes.resposta_email_de_quem_gerou === '04' ? 'bold' : ''">
              <td>Tive dificuldades para finalizar a compra.</td>
              <td>
                <v-checkbox
                  class="checks"
                  color="primary"
                  readonly
                  v-model="itemMostrarDetalhes.resposta_email_de_quem_gerou"
                  value="04"
                ></v-checkbox>
              </td>
            </tr>
            <tr :class="itemMostrarDetalhes.resposta_email_de_quem_gerou === '05' ? 'bold' : ''">
              <td>Preciso da ajuda de um consultor.</td>
              <td>
                <v-checkbox
                  class="checks"
                  color="primary"
                  readonly
                  v-model="itemMostrarDetalhes.resposta_email_de_quem_gerou"
                  value="05"
                ></v-checkbox>
              </td>
            </tr>
          </table>
        </v-col>
        <v-col v-if="itemMostrarDetalhes.resposta_email_de_quem_nao_gerou" class="ml-2">
          <div class="title mb-4">
            <h5 class="ml-2">RESPOSTA DE QUEM <b>NÃO</b> GEROU</h5>
          </div>
          <!-- <v-divider class="my-3 mb-4"/> -->
          <table style="width: 100%">
            <tr>
              <th>OPÇÕES</th>
              <th class="align-center" width="100px">RESPOSTA</th>
            </tr>
            <tr :class="itemMostrarDetalhes.resposta_email_de_quem_nao_gerou === '01' ? 'bold' : ''">
              <td>Você já conseguiu visualizar toda informação que precisava (medidas, quantidades e preço)</td>
              <td class="align-center checks">
                <v-checkbox
                  class="checks"
                  color="primary"
                  readonly
                  v-model="itemMostrarDetalhes.resposta_email_de_quem_nao_gerou"
                  value="01"
                ></v-checkbox>
              </td>
            </tr>
            <tr :class="itemMostrarDetalhes.resposta_email_de_quem_nao_gerou === '02' ? 'bold' : ''">
              <td>Você não necessita gerar o ORÇAMENTO IMPRESSO para que possa ser aprovado por um SUPERIOR</td>
              <td class="align-center checks">
                <v-checkbox
                  class="checks"
                  color="primary"
                  readonly
                  v-model="itemMostrarDetalhes.resposta_email_de_quem_nao_gerou"
                  value="02"
                ></v-checkbox>
              </td>
            </tr>
            <tr :class="itemMostrarDetalhes.resposta_email_de_quem_nao_gerou === '03' ? 'bold' : ''">
              <td>Você necessita de uma ajuda de um consultor para saber qual produto melhor se encaixa para a sua empresa</td>
              <td class="align-center checks">
                <v-checkbox
                  class="checks"
                  color="primary"
                  readonly
                  v-model="itemMostrarDetalhes.resposta_email_de_quem_nao_gerou"
                  value="03"
                ></v-checkbox>
              </td>
            </tr>
            <tr :class="itemMostrarDetalhes.resposta_email_de_quem_nao_gerou === '04' ? 'bold' : ''">
              <td>A quantidade de Lotes que trabalhamos não atende as suas necessidades</td>
              <td class="align-center checks">
                <v-checkbox
                  class="checks"
                  color="primary"
                  readonly
                  v-model="itemMostrarDetalhes.resposta_email_de_quem_nao_gerou"
                  value="04"
                ></v-checkbox>
              </td>
            </tr>
            <tr :class="itemMostrarDetalhes.resposta_email_de_quem_nao_gerou === '05' ? 'bold' : ''">
              <td>Você não conseguiu gerar o ORÇAMENTO por problemas em nosso site</td>
              <td class="align-center checks">
                <v-checkbox
                  class="checks"
                  color="primary"
                  readonly
                  v-model="itemMostrarDetalhes.resposta_email_de_quem_nao_gerou"
                  value="05"
                ></v-checkbox>
              </td>
            </tr>
          </table>
        </v-col>
        <v-col class="ml-2" v-if="!itemMostrarDetalhes.resposta_email_de_quem_gerou && !itemMostrarDetalhes.resposta_email_de_quem_nao_gerou">
          <div style="width: 100%; text-align: center">
            Esse pedido não possui respostas de email.
          </div>
        </v-col>
      </v-row>

      <v-card-actions style="padding: 0px; position: absolute; bottom: 0; right: 0" class="mb-n3">
        <v-row>
          <v-col align="end" justify="stretch" style="text-align: right;">
            <v-spacer></v-spacer>
            <v-btn color="warning" @click="fecharDialog()" dark small>
              <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
              Fechar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    itemMostrarDetalhes: Object,
    fecharDialog: Function
  },
  mounted () {
  }
}
</script>

<style scoped>
  h5 {
    font-size: 14px;
    color: rgb(45, 49, 85);
  }
  th {
    color: gray;
    border-bottom: 1px solid rgb(212, 212, 212);
  }
  table {
    border: 1px solid rgb(218, 218, 218);
    /* height: 100%; */
  }
  td {
    border-bottom: 1px solid rgb(218, 218, 218);
    text-align: justify;
    padding: 10px;
  }
  .align-center {
    text-align: center;
  }
  .checks {
    height: 30px;
    margin: 4px;
    margin-left: 25px;
  }
  .bold {
    background-color: rgba(131, 131, 131, 0.055);
    border-left: 4px solid #1976D2;
    font-weight: bold;
  }
</style>
